export default __webpack_public_path__ + "media/images/Brandfolder_logo-5cb5d166.png";